<template>
  <div v-if="checkIfProductIsNotAvailable1C" class="basket-product-not-available">
    {{ messages.notAvailableIn1C }}
  </div>
</template>

<script lang="ts" setup>
import { useStore } from '@/store';
import { computed } from 'vue';

const { state, getters } = useStore();

const props = defineProps(['result']);

const messages = computed(() => state.checkout.data?.vue?.messages);
const checkIfProductIsNotAvailable1C = computed(() =>
  getters['checkout/checkIfProductIsNotAvailable1C'](props.result.id)
);
</script>

<style lang="scss" scoped>
.basket-product-not-available {
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  padding: 8px 12px;
  background: #fff4f4;
  grid-column: 1 / -1;
}
</style>
